module.exports = __webpack_public_path__ + "assets/img/edit.3fabd5d3.svg";